<template>
  <ul class="sources-list">
    <li v-for="(s, i) in sources" :key="i">
      <div class="left">
        <span class="dot" :style="{background:s.color}"></span>
        <span class="name">{{ s.name }}</span></div>
      <div class="right">{{ s.count }} ({{ ((s.count/total)*100).toFixed(1) }}%)</div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SourcesList',
  props: { sources: { type: Array, default: () => [] }, total: { type: Number, default: 1 } }
};
</script>

<style scoped>
.sources-list {
  list-style:none;
  padding:0;
  margin:0.5rem 0 0 0
}
.sources-list li {
  display:flex;
  justify-content:space-between;
  padding:0.5rem 0;
  align-items:center
}
.dot {
  width:1rem;
  height:1rem;
  border-radius:50%;
  display:inline-block;
  margin-right:0.5rem
}
.left{
  display:flex;
  align-items:center
}
</style>